<template>
  <div>
    <div class="weui-cells__title">
      实名认证 - 支持 jpg/png/gif
      <span style="color: red">（不能超过4M）</span>
    </div>
    <div class="weui-cells weui-cells_form" id="uploader">
      <div class="weui-cell">
        <div class="weui-cell__bd">
          <div class="weui-uploader">
            <div class="weui-uploader__hd">
              <p class="weui-uploader__title">上传身份证正面照片（必须）</p>
              <div class="weui-uploader__info">
                <span id="uploadCount">{{ uploadCount }}</span
                >/1
              </div>
            </div>
            <div class="weui-uploader__bd">
              <ul class="weui-uploader__files" id="uploaderFiles">
                <li
                  class="weui-uploader__file"
                  v-if="userInfo.idCardUrl"
                  :style="'background-image:url(' + userInfo.idCardUrl + ')'"
                ></li>
              </ul>
              <div class="weui-uploader__input-box">
                <input
                  id="uploaderInput"
                  class="weui-uploader__input"
                  type="file"
                  accept="image/*"
                  multiple=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="weui-cell">
        <div class="weui-cell__bd">
          <p>姓名</p>
        </div>
        <div class="weui-cell__ft">
          {{ userInfo.realname ? userInfo.realname : "根据身份证自动识别" }}
        </div>
      </div>
      <div class="weui-cell">
        <div class="weui-cell__bd">
          <p>性别</p>
        </div>
        <div class="weui-cell__ft">
          {{ !userInfo.sex ? "根据身份证自动识别" : ""
          }}{{ userInfo.sex == 1 ? "男" : ""
          }}{{ userInfo.sex == 2 ? "女" : "" }}
        </div>
      </div>
      <div class="weui-cell">
        <div class="weui-cell__bd">
          <p>身份证号</p>
        </div>
        <div class="weui-cell__ft">
          {{ userInfo.idCardNo ? userInfo.idCardNo : "根据身份证自动识别" }}
        </div>
      </div>
    </div>
    <section class="mail-tips">
      <span style="font-size: 14px; font-weight: bold">温馨提示</span>
      <p style="font-size: 12px">
        申请跑腿必须上传自己的学生证，否则审核不通过。
      </p>
    </section>
    <div
      class="weui-cells weui-cells_form"
      id="studentUploader"
      style="margin-top: 0px"
    >
      <div class="weui-cell">
        <div class="weui-cell__bd">
          <div class="weui-uploader">
            <div class="weui-uploader__hd">
              <p class="weui-uploader__title">上传学生证照片（选填）</p>
              <div class="weui-uploader__info">
                <span id="studentUploadCount">{{ studentUploadCount }}</span
                >/1
              </div>
            </div>
            <div class="weui-uploader__bd">
              <ul class="weui-uploader__files" id="studentUploaderFiles">
                <li
                  class="weui-uploader__file"
                  v-if="userInfo.studentCardUrl"
                  :style="
                    'background-image:url(' + userInfo.studentCardUrl + ')'
                  "
                ></li>
              </ul>
              <div class="weui-uploader__input-box">
                <input
                  id="studentUploaderInput"
                  class="weui-uploader__input"
                  type="file"
                  accept="image/*"
                  multiple=""
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="warehousing-footer-item sureinwarehousing"
      style="flex: 2"
      @click="save"
    >
      <a href="javascript:;">提 交</a>
    </div>
  </div>
</template>
<script>
import weui from "weui.js";
import axios from "axios";
import config from "../../config/config.js";
import io from "socket.io-client";

export default {
  data() {
    return {
      type: "",
      encodeToken: "",
      token: "",
      redirect: "",
      idCardInfo: {},
      studentCardInfo: {},
      userInfo: {
        realname: "",
        idCardNo: "",
        sex: "",
      },
      uploadCount: 0,
      uploadList: [],
      studentUploadCount: 0,
      studentUploadList: [],
      loading: null,
      socket: null,
    };
  },
  created() {
    let that = this;
    this.type = this.$route.params.type;
    this.redirect = this.$route.params.redirect;
    this.encodeToken = this.$route.params.token;
    this.token = decodeURIComponent(this.encodeToken);
    axios.defaults.headers["Authorization"] = "Bearer " + this.token;

    // 根据token查找微信用户信息
    axios
      .get("/api/user/wxuserInfo")
      .then((res) => {
        if (res.data.success) {
          this.userInfo = res.data.data;

          if (this.userInfo.idCardUrl) {
            this.uploadList.push(this.userInfo.idCardUrl);
            this.uploadCount += 1;
          }
          if (this.userInfo.studentCardUrl) {
            this.studentUploadList.push(this.userInfo.studentCardUrl);
            this.studentUploadCount += 1;
          }
        } else {
          weui.alert("获取用户信息失败");
          console.log(res.data.message);
        }
      })
      .catch((err) => {
        weui.alert("获取用户信息失败");
      });
  },
  methods: {
    save() {
      let that = this;
      if (!this.idCardInfo.destFileName && !this.studentCardInfo.destFileName) {
        weui.alert("请上传身份证/学生证照片");
        return false;
      } else if (
        (!this.idCardInfo.destFileName && !this.userInfo.idCardUrl) ||
        !this.userInfo.realname
      ) {
        weui.alert("请上传真实的身份证");
        return false;
      } else if (
        this.type == 1 &&
        !this.userInfo.studentCardUrl &&
        !this.studentCardInfo.destFileName
      ) {
        // 跑腿实名认证，必须上传学生证
        weui.alert("跑腿实名认证须上传学生证");
        return false;
      }

      let params = {};
      if (this.idCardInfo.destFileName) {
        let idCardUrl = `${config.xytPreUrl}/sign/${this.idCardInfo.dateFolder}/${this.idCardInfo.destFileName}`;

        params.idCardUrl = idCardUrl;
        params.realname = this.userInfo.realname;
        params.idCardNo = this.userInfo.idCardNo;
        params.sex = this.userInfo.sex;
      }

      if (this.studentCardInfo.destFileName) {
        let studentCardUrl = `${config.xytPreUrl}/sign/${this.studentCardInfo.dateFolder}/${this.studentCardInfo.destFileName}`;
        params.studentCardUrl = studentCardUrl;
      }
      axios
        .put("/api/user/applyAuth", params)
        .then((res) => {
          if (res.data.success) {
            weui.toast("提交成功", 1000);
            // 跳转回个人中心页面
            that.$router.push("/" + that.redirect + "/" + that.encodeToken);
          } else {
            weui.alert(res.data.message);
          }
        })
        .catch((err) => {
          weui.alert("提交失败");
        });
    },
  },
  mounted() {
    let that = this;
    /**
     * 身份证自动上传
     */
    var uploadCountDom = document.getElementById("uploadCount");
    weui.uploader("#uploader", {
      url: "/api/upload/uploadFile",
      auto: true,
      type: "file",
      fileVal: "idCard",
      compress: {
        width: 800,
        height: 800,
        quality: 0.7,
      },
      onBeforeQueued: function (files) {
        if (
          ["image/jpg", "image/jpeg", "image/png", "image/gif"].indexOf(
            this.type
          ) < 0
        ) {
          weui.alert("请上传正确格式的图片");
          return false;
        }
        if (this.size > 4 * 1024 * 1024) {
          weui.alert("请上传不超过4M的图片");
          return false;
        }
        if (files.length > 1) {
          // 防止一下子选中过多文件
          weui.alert("最多只能上传1张图片");
          return false;
        }
        if (that.uploadCount + 1 > 1) {
          weui.alert("最多只能上传1张图片");
          return false;
        }

        that.loading = weui.loading("身份证识别中", {
          className: "custom-classname",
        });

        ++that.uploadCount;
        uploadCountDom.innerHTML = that.uploadCount;
      },
      onQueued: function () {
        that.uploadList.push(this);
      },
      onBeforeSend: function (data, headers) {
        headers["Authorization"] = "Bearer " + that.token;
        // return false; // 阻止文件上传
      },
      onProgress: function (procent) {
        //
      },
      onSuccess: function (ret) {
        that.loading.hide(function () {});
        if (ret.success) {
          that.idCardInfo = ret.data.uploadData;
          that.userInfo.realname = ret.data.ocrResult.realname;
          that.userInfo.idCardNo = ret.data.ocrResult.idCardNo;
          that.userInfo.sex = ret.data.ocrResult.sex;
        } else {
          weui.alert(ret.message);
          that.userInfo.realname = "";
          that.userInfo.idCardNo = "";
          that.userInfo.sex = "";
        }
      },
      onError: function (err) {
        that.loading.hide(function () {});
        console.log(err);
        weui.alert(err);
      },
    });

    // 缩略图预览
    document
      .querySelector("#uploaderFiles")
      .addEventListener("click", function (e) {
        var target = e.target;

        while (!target.classList.contains("weui-uploader__file") && target) {
          target = target.parentNode;
        }
        if (!target) return;

        var url = target.getAttribute("style") || "";
        var id = target.getAttribute("data-id");

        if (url) {
          url = url.match(/url\((.*?)\)/)[1].replace(/"/g, "");
        }
        var gallery = weui.gallery(url, {
          className: "custom-name",
          onDelete: function () {
            weui.confirm("确定删除该图片？", function () {
              --that.uploadCount;
              uploadCountDom.innerHTML = that.uploadCount;
              that.idCardInfo = {};
              that.userInfo.realname = "";
              that.userInfo.idCardNo = "";
              that.userInfo.sex = "";

              for (var i = 0, len = that.uploadList.length; i < len; ++i) {
                var file = that.uploadList[i];
                if (id && file.id && file.id == id) {
                  file.stop();
                  break;
                }
              }
              that.uploadList = [];
              target.remove();
              gallery.hide();
            });
          },
        });
      });

    /**
     * 学生证自动上传
     */
    var studentUploadCount = 0,
      studentUploadList = [];
    var studentUploadCountDom = document.getElementById("studentUploadCount");
    weui.uploader("#studentUploader", {
      url: "/api/upload/uploadFile",
      auto: true,
      type: "file",
      fileVal: "studentCard",
      compress: {
        width: 800,
        height: 800,
        quality: 0.7,
      },
      onBeforeQueued: function (files) {
        if (
          ["image/jpg", "image/jpeg", "image/png", "image/gif"].indexOf(
            this.type
          ) < 0
        ) {
          weui.alert("请上传图片");
          return false;
        }
        if (this.size > 4 * 1024 * 1024) {
          weui.alert("请上传不超过4M的图片");
          return false;
        }
        if (files.length > 1) {
          // 防止一下子选中过多文件
          weui.alert("最多只能上传1张图片");
          return false;
        }
        if (that.studentUploadCount + 1 > 1) {
          weui.alert("最多只能上传1张图片");
          return false;
        }

        ++that.studentUploadCount;
        studentUploadCountDom.innerHTML = that.studentUploadCount;
      },
      onQueued: function () {
        that.studentUploadList.push(this);
      },
      onBeforeSend: function (data, headers) {
        headers["Authorization"] = "Bearer " + that.token;
        // return false; // 阻止文件上传
      },
      onProgress: function (procent) {},
      onSuccess: function (ret) {
        if (ret.success) {
          that.studentCardInfo = ret.data;
        } else {
          weui.alert(ret.message);
        }
      },
      onError: function (err) {
        console.log(err);
      },
    });

    // 缩略图预览
    document
      .querySelector("#studentUploaderFiles")
      .addEventListener("click", function (e) {
        var target = e.target;

        while (!target.classList.contains("weui-uploader__file") && target) {
          target = target.parentNode;
        }
        if (!target) return;

        var url = target.getAttribute("style") || "";
        var id = target.getAttribute("data-id");

        if (url) {
          url = url.match(/url\((.*?)\)/)[1].replace(/"/g, "");
        }
        var gallery = weui.gallery(url, {
          className: "custom-name",
          onDelete: function () {
            weui.confirm("确定删除该图片？", function () {
              --that.studentUploadCount;
              studentUploadCountDom.innerHTML = that.studentUploadCount;
              that.studentCardInfo = {};

              for (
                var i = 0, len = that.studentUploadList.length;
                i < len;
                ++i
              ) {
                var file = that.studentUploadList[i];
                if (file.id && id && file.id == id) {
                  file.stop();
                  break;
                }
              }
              target.remove();
              gallery.hide();
            });
          },
        });
      });
  },
};
</script>

<style scoped>
.warehousing-footer-item {
  flex: 1;
  font-size: 18px;
  text-align: center;
  background-color: #1aad19;
  margin-top: 10px;
  line-height: 50px;
}
.warehousing-footer-item a {
  color: #ffffff;
}
.weui-cells_form .weui-cell__ft {
  font-size: 17px;
}
.mail-tips {
  text-align: left;
  padding: 10px;
  padding-left: 15px;
  background-color: lightyellow;
}
</style>





// WEBPACK FOOTER //
// src/components/userinfos/AuthApply.vue